import { Icon } from './icon';

export function PageTitle({ text, subtext, iconClass }: { text: string; subtext?: string; iconClass?: string }) {
  return (
    <div>
      <h1 className="flex items-center gap-3 py-0.5 font-serif text-3xl font-medium">
        {iconClass && <Icon className={`${iconClass} -mb-1 text-2xl text-gray-500`} />}
        <span className="line-clamp-1 break-all">{text}</span>
      </h1>
      {subtext && <p className="my-2 text-gray-600">{subtext}</p>}
    </div>
  );
}
